import { useEffect, useState } from 'react'
import { Layout, Button, Row, Col, Progress, Space, Result, Tabs, Input } from 'antd'
import { MehOutlined, LoadingOutlined, CodeOutlined } from '@ant-design/icons'
import { Loading } from 'Components'
import axios from 'axios'
import { pluginStatuses } from 'Services/ActionsPagesUtils'
import './general.scss'
import Feather from '@sysunite/react-feather'
import { ResizableBox } from 'react-resizable'
import {
  getRandomErrorTitle
  getRandomInit
  getRandomPending
  getRandomProgress
  getRandomDone
} from '../funnies'

{ TabPane } = Tabs
{ TextArea } = Input

GeneralTemplate = ({
  InputHandler,
  ResponseHandler
}) ->
  ({
    serviceName,
    serviceCall,
    component,
    title,
    description,
    parameters...
  }) ->

    [feedback, setFeedback] = useState()
    [logs, setLogs] = useState([])
    [activeTab, setActiveTab] = useState('action')
    [progress, setProgress] = useState({})
    [uploadFileProgress, setUploadFileProgress] = useState()
    [inputState, setInputState] = useState()

    backButton = (
      <Button
        type="text"
        shape="round"
        onClick={-> setActiveTab('action')}
      >
        Back
      </Button>
    )

    retryButton = (
      <Button
        type="primary"
        shape="round"
        ghost
        onClick={->
          setFeedback(undefined)
          setUploadFileProgress(undefined)
        }
      >
        Retry
      </Button>
    )

    useEffect(->
      return unless log = document.querySelector('.logs')
      log.scrollTop = log.scrollHeight
      undefined
    , [logs])

    showError = ->
      setFeedback({
        type: pluginStatuses.ERRORED
        title: getRandomErrorTitle()
        message: "There was an error during the service process. Please check the logs for additional info, or contact a project administrator for further assistance."
        extra: retryButton
      })

      setInputState((state) ->
        state?[0]?.status = pluginStatuses.ERRORED
        state
      )

    startPlugin = (pluginArgs) ->
      setLogs([])
      setProgress({})

      try
        plugin = await Weaver.Plugin.load(serviceName)
      catch e
        setFeedback({
          type: pluginStatuses.ERRORED
          title: getRandomErrorTitle()
          message: "The configuration for this service is invalid. No plugin '#{ serviceName }' exists. Contact a project administrator for more information."
          extra: retryButton
        })
      unless plugin[serviceCall]
        setFeedback({
          type: pluginStatuses.ERRORED
          title: getRandomErrorTitle()
          message: "The configuration for this service is invalid. No function '#{ serviceCall }' exists for plugin '#{ serviceName }'. Contact a project administrator for more information."
          extra: retryButton
        })

      try
        setFeedback({
          type: pluginStatuses.INIT
          title: 'Hold tight!'
          icon: <LoadingOutlined />
          message: getRandomInit()
        })

        operationJson = await plugin[serviceCall]({
          parameters...,
          pluginArgs...
        }, (uploadProgress) ->
          setFeedback(undefined)
          setUploadFileProgress(uploadProgress)
        )

        report = JSON.parse(operationJson)
        pluginProgressPoller = setInterval(->

          try
            operationJson = await plugin.getStatus({ operationId: report.id })
            report = JSON.parse(operationJson)
            percent = Math.ceil((report.progress / report.scale ) * 100)
          catch e
            report = {
              errored: true
              pending: false
              done: false
              message: e.message
            }

          if report.pending
            setFeedback({
              type: pluginStatuses.PENDING
              icon: <LoadingOutlined />
              title: "The service is paused, pending completion of another service."
              message: getRandomPending()
            })
          else
            setProgress({ percent })
            setFeedback({
              type: pluginStatuses.PROGRESS
              icon: <Progress type="circle" percent={percent} />
              title: "The service is currently in progress."
              message: getRandomProgress()
            })
          if report.done
            setProgress({ percent: 100, status: 'success' })
            setFeedback({
              type: pluginStatuses.DONE
              title: "The service has completed successfully."
              message: getRandomDone()
              extra: (
                <ResponseHandler
                  restart={->
                    setFeedback(undefined)
                    setUploadFileProgress(undefined)
                  }
                  response={report}
                /> if ResponseHandler?
              )
            })

            setInputState((state) ->
              state?[0]?.status = pluginStatuses.DONE
              state
            )

          if report.log
            setLogs(report.log)
          if report.errored
            setLogs((logs) -> [
              logs...
              report.message
            ]) if report.message?
            setProgress({ percent: 100, status: 'exception' })
            showError()
          if report.done or report.errored
            clearInterval(pluginProgressPoller)
        , 1000)
      catch e
        console.log(e)
        showError()

    unless feedback?
      if InputHandler?
        <InputHandler
          inputState={inputState}
          setInputState={setInputState}
          startPlugin={startPlugin}
          uploadFileProgress={uploadFileProgress}
        />
      else
        <Button
          type="primary"
          shape="round"
          block
          ghost
          onClick={-> startPlugin()}
        >
          Run
        </Button>
    else
      <Tabs
        activeKey={activeTab}
        renderTabBar={-> undefined}
      >
        <TabPane key="action">
          <Result
            status={feedback.type}
            icon={feedback.icon}
            title={feedback.title}
            subTitle={feedback.message}
            extra={
              <>
                { feedback.extra }
                <Button
                  shape="round"
                  type="text"
                  onClick={->
                    setActiveTab('logs')
                  }
                >
                  Show logs
                </Button>
              </>
            }
          />
        </TabPane>
        <TabPane key="logs">
          {
            if logs.length > 0
              <>
                <Space direction='vertical'>
                  <Row gutter={8} align="middle">
                    <Col>
                      { backButton }
                    </Col>
                    <Col flex={1}>
                      <Progress status={progress.status} percent={progress.percent} />
                    </Col>
                  </Row>
                  <ResizableBox
                    height={400}
                    width={Infinity}
                    minConstraints={[80, 80]}
                    axis="y"
                    handle={
                      <div
                        className="resize-handler"
                      >
                        <Feather
                          strokeWidth={2}
                          size='2em'
                          type="chevron-down"
                        />
                      </div>
                    }
                  >
                    <TextArea
                      className="logs"
                      value={logs.join('\n')}
                    />
                  </ResizableBox>
                </Space>
              </>
            else
              <Result
                status='info'
                icon={<MehOutlined />}
                title="You're early to the party!"
                subTitle='Nothing here to show yet'
                extra={backButton}
              />
          }
        </TabPane>
      </Tabs>

export default GeneralTemplate
